// @ts-nocheck
import React, { useContext, useEffect, useState } from "react";
import TextTransition, { presets } from "react-text-transition";
import { SiteContext } from "./global/site-context";
import { cn } from "../lib/helpers";

const TEXT_ROTATE_DELAY = 1200;
const TEXT_ROTATE_TIME = 2000;

/**
 * @typedef {Object} RotateText
 *
 * @prop {React.ReactNode} prefix
 * @prop {string=} className
 */

/**
 * @type {React.VFC<RotateText>}
 */
export const RotateText = ({
  prefix,
  suffix,
  words,
  colors,
  // longest,
  className,
  wordClass,
  spacing = "1.5",
  speed = TEXT_ROTATE_TIME,
  delay = TEXT_ROTATE_DELAY,
}) => {
  const [index, setIndex] = useState(0);
  // Bumped to force TextTransition to remount after the tab regains focus,
  // so react-spring starts fresh instead of resuming a stale animation with
  // a huge elapsed time (which makes the text jump then snap back).
  const [mountKey, setMountKey] = useState(0);

  const site = useContext(SiteContext);

  useEffect(() => {
    let timeoutId;
    let intervalId;

    const startRotation = () => {
      timeoutId = setTimeout(() => {
        intervalId = setInterval(() => setIndex((index) => index + 1), speed);
      }, delay);
    };

    const stopRotation = () => {
      clearTimeout(timeoutId);
      clearInterval(intervalId);
    };

    const handleVisibilityChange = () => {
      if (document.hidden) {
        stopRotation();
      } else {
        setMountKey((key) => key + 1);
        startRotation();
      }
    };

    startRotation();
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      stopRotation();
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [speed, delay]);

  return (
    <div className={cn("inline-flex", className)}>
      {prefix ? <span>{prefix}</span> : null}
      <div
        style={{ color: colors ? colors[index % colors.length] : null }}
        className={cn(
          prefix ? `ml-${spacing}` : null,
          suffix ? `mr-${spacing}` : null,
          wordClass,
          "flex justify-center items-center text-center"
        )}
      >
        {site.isBrowser ? (
          <TextTransition key={mountKey} springConfig={presets.slow} direction="up">
            {words[index % words.length]}
          </TextTransition>
        ) : (
          words[0]
        )}
      </div>
      {suffix ? <span>{suffix}</span> : null}
    </div>
  );
};
